module.exports = __webpack_public_path__ + "img/course73_curriculum.a25123b4.png";